<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'CashBills',
  data () {
    return {
    }
  },
  mounted () {
    this.$store.dispatch('cashBill/reset')
    this.$store.dispatch('systemSetting/loadSystemSettings')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/cashBills/index.vue